import React from "react";
import { CellUserModalActions } from "../../../common/cell.component";
import TableView from "../../../../../Basic/TableView";

var RequestUserTable = function RequestUserTable(props) {
  var data = props.data,
      formData = props.formData,
      prefix = props.prefix,
      translate = props.translate,
      editFormUser = props.editFormUser,
      deleteFormUser = props.deleteFormUser;
  var columns = [{
    id: "Name",
    isFilterable: false,
    isSortable: false,
    disableHeaderSort: true,
    Header: translate('SFxAccountSettingsUserTableNameTitle'),
    headerStyle: {
      minWidth: 170
    },
    style: {
      minWidth: 170
    },
    minWidth: 170,
    Cell: function Cell(row) {
      var _row$original = row.original,
          LastName = _row$original.LastName,
          FirstName = _row$original.FirstName;
      return /*#__PURE__*/React.createElement("span", null, "".concat(FirstName, " ").concat(LastName));
    }
  }, {
    id: "Email",
    isFilterable: false,
    isSortable: false,
    disableHeaderSort: true,
    Header: translate('SFxAccountSettingsUserEmailLabel'),
    headerStyle: {
      minWidth: 170
    },
    style: {
      minWidth: 170
    },
    minWidth: 170,
    Cell: function Cell(row) {
      var userName = row.original.userName;
      return /*#__PURE__*/React.createElement("span", null, userName);
    }
  }, {
    id: "Solutions",
    isFilterable: false,
    isSortable: false,
    disableHeaderSort: true,
    Header: translate('SFxAccountSettingsUserRequestColumnSolution'),
    headerStyle: {
      minWidth: 160
    },
    style: {
      minWidth: 160
    },
    minWidth: 160,
    Cell: function Cell(row) {
      var selectedSolution = row.original.selectedSolution;

      if (selectedSolution) {
        return selectedSolution.map(function (i) {
          return /*#__PURE__*/React.createElement("div", {
            key: i.id
          }, i.name);
        });
      } else {
        return '';
      }
    }
  }, {
    id: "_actions",
    Header: "",
    isFilterable: false,
    isSortable: false,
    disableHeaderSort: true,
    headerStyle: {
      minWidth: 70
    },
    style: {
      minWidth: 70
    },
    minWidth: 70,
    className: "disable-resize",
    headerClassName: "disable-resize",
    Cell: function Cell(row) {
      return /*#__PURE__*/React.createElement(CellUserModalActions, {
        row: row,
        formUser: formData,
        editFormUser: editFormUser,
        deleteFormUser: deleteFormUser
      });
    }
  }];
  return /*#__PURE__*/React.createElement(TableView, {
    className: "".concat(prefix, "-user-modal-table"),
    data: data,
    columns: columns,
    showPagination: false
  });
};

export default RequestUserTable;